<template>
    <modal class="modal-cash-out" v-model="viewOn" title="Cash out" size="sm" v-on:show="initBeeCash">
        <div class="container-fluid" v-if="state=='init'">
            <form class="form-horizontal" @submit.prevent="checkout">
                <div class="from-group">
                    <label class="control-label col-sm-2" for="caBrands">TO</label>
                    <div class="input-hold col-sm-10" id="caBrands">
                        <select v-model="receiver">
                            <option v-for="card in cards" v-bind:value="card.id">{{card.id}}</option>
                        </select>
                    </div>
                </div>
                <div class="from-group">
                    <label class="control-label col-sm-2" for="div-balance-card">BALANCE</label>
                    <div class="input-hold col-sm-10" id="div-balance-card">
                        <input type="text" v-bind:value="balance" class="" id="input-balance-card" name="uName"
                               placeholder="" required readonly>
                    </div>
                </div>
                <div class="from-group">
                    <label class="control-label col-sm-2" id="div-amount" for="div-amount">AMOUNT</label>
                    <div class="input-hold col-sm-10">
                        <input type="text" v-model="amount.value" class="" id="amount-cash-out" placeholder=""
                               required>
                        <label class="error" for="amount-cash-out" v-if="amount.error">{{amount.error}}</label>
                    </div>
                </div>
                <div class="form-control progress progress-control" v-if="working">
                    <div class="progress-bar progress-bar-success progress-bar-striped active progress-transfer"
                         role="progressbar"
                         aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <label class="error general-error" v-if="error">{{error}}</label>
            </form>
        </div>
        <div class="container-fluid" v-if="state=='agree'">
            <p>Do you want cash out {{amount.value}}{{currency}}?</p>
            <div class="form-control progress progress-control" v-if="working">
                <div class="progress-bar progress-bar-success progress-bar-striped active progress-transfer"
                     role="progressbar"
                     aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <label class="error general-error" v-if="error">{{error}}</label>
        </div>
        <div slot="footer" v-if="state=='agree'">
            <btn @click="state='init'" v-bind:disabled="working">Back</btn>
            <btn @click="cashOut" v-bind:disabled="working">OK</btn>
            <btn @click="viewOn=false" v-bind:disabled="working">Cancel</btn>
        </div>
        <div slot="footer" v-if="state=='init'">
            <btn @click="next('agree')" v-bind:disabled="working">Next</btn>
        </div>
    </modal>
</template>

<script>
    export default {
        name: 'cash-out',
        dependencies: ['service'],
        props: ['view'],
        data: function () {
            return {
                currency:'',
                state: 'init',
                open: false,
                working: false,
                amount: {
                    value: 0, error: '', validator: {
                        rules: {
                            required: true,
                            max: 0,
                            format: 'number'
                        },
                        messages: {
                            required: "Please provide an amount",
                            max: "Amount is to big",
                            format: "Illegal number format"
                        }
                    }
                },
                error: '',
                cards: [],
                receiver: ''
            }
        },
        computed: {
            viewOn: {
                get: function () {
                    return this.view
                },
                set: function (value) {
                    this.$emit('view-change', value)
                }
            },
            balance: function () {
                let card = this.cards.find(v => v.id == this.receiver);
                return card ? card.balance : '';
            }
        },
        methods: {
            initBeeCash() {
                this.currency = sessionStorage.currency;
                this.state = 'init';
                this.error = '';
                this.cards = [];
                this.amount.value = 0;
                this.amount.error = '';
                this.working = true;
                this.service.cards().then(r => {
                    if (r.data.errorCode == 0) {
                        this.cards = r.data.cards;
                        this.receiver = this.cards[0].id;
                    } else
                        this.error = r.data.description;
                }).catch(e => {
                    if (e.response) {
                        this.error = e.response.data.description;
                    }
                }).finally(() => this.working = false);

                this.service.getBalance().then(r => {
                    this.amount.value = r.data.balance;
                    this.amount.validator.rules.max = r.data.balance;
                }).catch(error => {
                    if (error.response) {
                        console.log(error.response.status);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            },
            next(state) {
                if (!this.validate(this.amount)) return;
                this.state = state;
            },
            cashOut() {
                this.working = true;
                this.error  = '';
                this.service.cashOut(this.receiver, this.amount.value).then(r => {
                    if (r.data.errorCode == 0) {
                        this.viewOn = false;
                        this.state = 'init';
                        this.$emit('balance-change');
                    } else
                        this.error = r.data.description;
                }).catch(e => {
                    if (e.response)
                        if (e.response.data)
                            if (e.response.data.description) {
                                this.error = e.response.data.description;
                                return;
                            }
                    this.error = 'General error';
                }).finally(() => this.working = false);
            },
            validate: (field) => {
                field.error = '';
                let rules = field.validator.rules;
                let messages = field.validator.messages;
                for (let rule in rules) {
                    if (rule === 'required' && rules[rule]) {
                        if (!field.value) {
                            field.error = messages[rule];
                            return false;
                        }
                    } else if (rule === 'minlength') {
                        if (field.value.length < rules[rule]) {
                            field.error = messages[rule];
                            return false;
                        }
                    } else if (rule === 'max') {
                        let number = Number(field.value);
                        if (number > rules[rule]) {
                            field.error = messages[rule];
                            return false;
                        }
                    } else if (rule === 'format') {
                        let number = Number(field.value)
                        if (rules[rule] == 'number' && isNaN(number)) {
                            field.error = messages[rule];
                            return false;
                        }
                    }
                }
                return true;
            }
        }
    }
</script>

<style scoped>

</style>